import algoliasearch from 'algoliasearch';
import { AlgoliaIndexes } from 'models/products';

export const searchClient = algoliasearch(
  process.env.ALGOLIA_APP_ID as string,
  process.env.ALGOLIA_SEARCH_API_KEY as string,
);

export const algoliaIndex = searchClient.initIndex(AlgoliaIndexes.Products);
